import { defineMessages } from "react-intl";

// Pane-owned ids sit under leadFinder.resultsPane.*; ids used by
// the child Title component (ResultsPane/Title.tsx) sit under
// leadFinder.resultsPane.title.* to mirror the component tree.
const messages = defineMessages({
  clearSelected: {
    id: "leadFinder.resultsPane.clearSelected",
    defaultMessage: "Clear selected",
    description: "Clear selected button title",
  },
  count: {
    id: "leadFinder.resultsPane.count",
    defaultMessage: "{count, plural, =0 {No results} one {{count} result} other {{count} results}}",
    description: "Lead Finder results panel - records count",
  },
  dropDownTooltip: {
    id: "leadFinder.resultsPane.title.dropdownTooltip",
    defaultMessage: "Tap to show result options",
    description: "Lead Finder filter Dropdown tooltip",
  },
  emptySelection: {
    id: "leadFinder.resultsPane.emptySelection",
    defaultMessage: "No leads selected yet",
    description: "Lead Finder results panel - no selection",
  },
  hideToggleTooltip: {
    id: "leadFinder.resultsPane.title.hideToggleTooltip",
    defaultMessage:
      "If you know a lead will never be a good fit, you can hide the result. Hidden results can always be toggled into view as needed.",
    description: "Lead Finder Dropdown Hide hidden records tooltip",
  },
  searchPlaceholder: {
    id: "leadFinder.resultsPane.searchPlaceholder",
    defaultMessage: "Search lead results",
    description: "Lead results - search placeholder",
  },
  selectAllLeads: {
    id: "leadFinder.resultsPane.selectAllLeads",
    defaultMessage: "{allVisible, select, true {Select all leads} other {Select leads}}",
    description: "Select all leads default title",
  },
  selected: {
    id: "leadFinder.resultsPane.selected",
    defaultMessage:
      "{selectedRecordsCount}/{total} {selectedRecordsCount, plural, one {Lead} other {Leads}} Selected",
    description: "Lead Finder results panel - number of selected records",
  },
  showDuplicates: {
    id: "leadFinder.resultsPane.title.showDuplicates",
    defaultMessage: "Show potential duplicates",
    description: "Lead Finder filter Dropdown Show potential duplicate records toggle title",
  },
  showHiddenResults: {
    id: "leadFinder.resultsPane.title.showHiddenResults",
    defaultMessage: "Show hidden results",
    description: "Lead Finder filter Dropdown Show hidden records toggle title",
  },
  title: {
    id: "leadFinder.resultsPane.title.label",
    defaultMessage: "Lead Finder",
    description: "Lead Finder's record list default title",
  },
  titleBasic: {
    id: "leadFinder.resultsPane.title.basicLabel",
    defaultMessage: "Lead Finder Basic",
    description: "Lead Finder Basic record list default title",
  },
});

export default messages;
